const subscriptionBasedHousehold = [
	{
		id: '6301',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Set (Bed sheet, Bed cover, Bed runner)',
		description: 'Bed sheet-2pcs, Bed cover-2pcs, Bed runner-1pcs',
		category: 'Household',
		service: 'Subscription Based',
		price: 240,
		quantity: 1
    },
    
	{
		id: '6302',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket Set (Blanket, Blanket Cover)',
		description: 'Blanket-2pcs, Blanket Cover-2pcs',
		category: 'Household',
		service: 'Subscription Based',
		price: 650,
		quantity: 1
    },
    
	{
		id: '6303',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Tools Cover (Table Cover, Sofa Cover)',
		description: 'Table Cover-2pcs, Sofa Cover-4pcs, Car Seat Cover-6pcs',
		category: 'Household',
		service: 'Subscription Based',
		price: 180,
		quantity: 1
	}
];

export default subscriptionBasedHousehold;
